import React from 'react'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '../../styles'
import type { PaperProps as MuiPaperProps } from '@material-ui/core/Paper'
import { default as MuiPaper } from '@material-ui/core/Paper'

const useStyles = makeStyles<Theme, PaperProps>(
  (_theme) => ({
    root: {
      '@media print': {
        boxShadow: 'none !important'
      }
    }
  }),
  { name: 'Paper' }
)

export interface PaperProps extends Omit<MuiPaperProps, 'classes'> {
  classes?: StyleClasses<typeof useStyles>
}

function Paper(props: PaperProps) {
  const classes = useStyles(props)

  return <MuiPaper classes={classes} {...props} />
}

export default Paper
